import React, {PureComponent} from "react";
import "../resources/css/progression.css";
import {ProgressionLevelEntity} from "../data/entities/ProgressionLevelEntity";
import {UserContext} from "../context/UserContext";
import {ScaleLoader} from "react-spinners";
import ProgressionLevelProgressBar from "./PlayerProgression/ProgressionLevelProgressBar";
import CurrentUserProgressionLevel from "./PlayerProgression/CurrentUserProgressionLevel";
import {FormattedMessage} from "react-intl";
import ErrorMessage from "./ErrorMessage";
import {UserProgressionInfoEntity} from "../data/entities/UserProgressionInfoEntity";

interface Props {
    progressionLevels: ProgressionLevelEntity[];
    isLoadingProgressionWidget: boolean;
    userProgressionInfo: UserProgressionInfoEntity;
    hasError: boolean;
    refreshProgressionData: () => void;
}

export default class PlayerProgressionStatus extends PureComponent<Props> {
    static contextType = UserContext;
    context!: React.ContextType<typeof UserContext>;

    getPlayerAvatar() {
        return <img
            src={`${process.env.REACT_APP_AVATAR_BASE_URL}${this.context.user.ticketData.userId}/default_146_146.png?appId=${process.env.REACT_APP_APP_ID}&tm=${new Date().getTime()}`}
            alt={(this.context.user.username !== null) ? this.context.user.username : ''}
            className="playerAvatar"
        />
    }


    render(): JSX.Element {
        return (
            <React.Fragment>
                <div className="containerSection" id="nav-anchor-progression">
                    <div className="playerProgression">
                        {
                            this.props.hasError &&
                                <div className="text-center block pt-5">
                                    <ErrorMessage
                                        message={<FormattedMessage id="message.error"/>}
                                        onRefresh={this.props.refreshProgressionData}
                                    />
                                </div>
                        }
                        {
                            this.props.isLoadingProgressionWidget &&
                            <div className="item-loader">
                                <ScaleLoader color={'#fff'}/>
                            </div>
                        }
                        {
                            !this.props.isLoadingProgressionWidget && !this.props.hasError &&
                                <React.Fragment>
                                    <div className="d-flex flex-row">
                                        <div className="tiny-hidden playerAvatarContainer">
                                            {this.getPlayerAvatar()}
                                        </div>
                                        <div className="playerSubscriptionInfo">
                                            <h3>{this.context.user.username}</h3>
                                            <CurrentUserProgressionLevel
                                                userProgressionInfo={this.props.userProgressionInfo}
                                            />
                                            <div className="d-block hideOnTabletAndSmaller">
                                                <ProgressionLevelProgressBar
                                                    progressionLevels={this.props.progressionLevels}
                                                    userProgressionInfo={this.props.userProgressionInfo}
                                                />
                                            </div>

                                        </div>
                                    </div>

                                    <div className="d-none showOnTabletAndSmaller">
                                        <ProgressionLevelProgressBar
                                        progressionLevels={this.props.progressionLevels}
                                        userProgressionInfo={this.props.userProgressionInfo}
                                        />
                                    </div>
                                </React.Fragment>
                        }
                    </div>
                </div>
            </React.Fragment>
        );
    }
}